module.exports = __webpack_public_path__ + "static/media/piazza-della-vittoria.cbe34ce2.svg";